import { render, staticRenderFns } from "./Suduzyz.vue?vue&type=template&id=0917fcb8&scoped=true&"
import script from "./Suduzyz.vue?vue&type=script&lang=js&"
export * from "./Suduzyz.vue?vue&type=script&lang=js&"
import style0 from "./Suduzyz.vue?vue&type=style&index=0&id=0917fcb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0917fcb8",
  null
  
)

export default component.exports